/* eslint-disable quotes */
import { createTheme } from '@mui/material';

export const LightTheme = createTheme({
  palette: {
    primary: {
      main: '#4a90e2',
      dark: '#357abd',
      light: '#6ba8e8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#78909c',
      dark: '#546e7a',
      light: '#90a4ae',
      contrastText: '#ffffff',
    },
    error: {
      main: '#f44336',
      dark: '#d32f2f',
      light: '#ef5350',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#ff9800',
      dark: '#f57c00',
      light: '#ffb74d',
      contrastText: '#ffffff',
    },
    info: {
      main: '#2196f3',
      dark: '#1976d2',
      light: '#64b5f6',
      contrastText: '#ffffff',
    },
    success: {
      main: '#4caf50',
      dark: '#388e3c',
      light: '#66bb6a',
      contrastText: '#ffffff',
    },

    // ✔ Branco fosco (zero brilho)
    background: {
      paper: '#f9fafb',     // branco suave
      default: '#f3f4f6',   // tom areado/acizentado suave
    },

    text: {
      primary: '#2c3e50',
      secondary: '#546e7a',
      disabled: '#b0bec5',
    },

    divider: 'rgba(0, 0, 0, 0.08)',
  },

  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',

    h1: { fontWeight: 600, color: '#2c3e50', fontSize: '2.5rem' },
    h2: { fontWeight: 600, color: '#2c3e50', fontSize: '2rem' },
    h3: { fontWeight: 600, color: '#2c3e50', fontSize: '1.75rem' },
    h4: { fontWeight: 500, color: '#2c3e50', fontSize: '1.5rem' },
    h5: { fontWeight: 500, color: '#2c3e50', fontSize: '1.25rem' },
    h6: { fontWeight: 500, color: '#2c3e50', fontSize: '1.1rem' },

    subtitle1: { color: '#546e7a' },
    subtitle2: { color: '#78909c' },

    body1: { color: '#37474f', lineHeight: 1.6, fontSize: '1rem' },
    body2: { color: '#546e7a', lineHeight: 1.5, fontSize: '0.875rem' },

    caption: { color: '#78909c' },
    overline: { color: '#78909c' },
  },

  shape: { borderRadius: 8 },

  components: {
    // ======================================
    // APPBAR (tira brilho total)
    // ======================================
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9fafb',
          color: '#2c3e50',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
        },
      },
    },

    // ======================================
    // PAPER — usado MUITO nas listagens
    // ======================================
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9fafb',  // branco fosco
          backgroundImage: 'none',
        },
      },
    },

    // ======================================
    // CARD — antes estava branco puro
    // ======================================
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9fafb',
          border: '1px solid rgba(0,0,0,0.05)',
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        },
      },
    },

    // ======================================
    // CAMPOS DE TEXTO — antes super brancos
    // ======================================
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#f3f4f6', // fundo suave
          borderRadius: 10,
          transition: '0.2s ease',

          '&:hover': {
            backgroundColor: '#e5e7eb', // ainda mais suave
          },
          '&.Mui-focused': {
            backgroundColor: '#eef1f4',
          },
        },
      },
    },

    // ======================================
    // TABELAS (antes 100% brancas)
    // ======================================
   

   

    // ======================================
    // BUTTONS
    // ======================================
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 500,
        },

        containedPrimary: {
          '&:hover': {
            backgroundColor: '#357abd',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(74,144,226,0.3)',
          },
        },

        outlined: {
          borderWidth: 1.5,
          '&:hover': {
            borderWidth: 1.5,
            transform: 'translateY(-1px)',
          },
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: { backgroundColor: 'rgba(0, 0, 0, 0.05)' },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(74,144,226,0.1)',
          borderRadius: 4,
        },
        bar: { borderRadius: 4 },
      },
    },
  },

  // ======================================
  // SHADOWS — Fix de TypeScript (25 itens)
  // ======================================
  shadows: [
    "none",
    "0 1px 3px rgba(0,0,0,0.05)",
    "0 2px 6px rgba(0,0,0,0.06)",
    "0 4px 12px rgba(0,0,0,0.07)",
    "0 6px 18px rgba(0,0,0,0.08)",

    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",

    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",

    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",

    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 2px 4px rgba(0,0,0,0.05)",
  ],
});
